import React, { useEffect, useState } from "react";
import { Loading } from "../../../componentes/loading/loading";
import { reduzirNome } from "../../../utils/reduzirNome";
import Modal from "../../../componentes/modal/modal";
import { formatarMoedaBrasileira } from "../../../utils/formatarMoedaBrasileira";
import { returnDate } from "../../../utils/formatDate";
import BPService from "../../../services/resource/bpService";
import PageAPI from "../../../componentes/pagination/Pagination-Page";
import DespesaService from "../../../services/resource/DespesaService";
import TabelaDespesas from "./TabelaDespesas";
import { Dialog } from "primereact/dialog";
import { exportarPrevistoRealizadoExcel } from "./exportarPrevistoRealizadoExcel";

// ─── Design tokens ────────────────────────────────────────────────────────────
export const T = {
  bg: "#F7F9FC",
  surface: "#FFFFFF",
  surfaceAlt: "#F1F5F9",
  border: "#E2E8F0",
  borderStrong: "#CBD5E1",
  text: "#0F172A",
  textMid: "#475569",
  muted: "#94A3B8",
  primary: "#2563EB",
  primaryLight: "#EFF6FF",
  secondary: "#64748B",
  green: "#16A34A",
  greenLight: "#F0FDF4",
  red: "#DC2626",
  redLight: "#FEF2F2",
  blue: "#0EA5E9",
  blueLight: "#F0F9FF",
  acum: "#EEF2FF",
  acumText: "#4338CA",
  total: "#F8FAFC",
};

const FONT = "var(--font-sans)";

// ─── Helpers ──────────────────────────────────────────────────────────────────
const moeda = (v) =>
  v?.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) ?? "—";

const initialLista = {
  content: [],
  page: { size: 20, number: 0, totalElements: 0, totalPages: 0 },
};

// ─── Sub-components ───────────────────────────────────────────────────────────

const InputSearch = ({ value, onChange, ano, setAno }) => (
  <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
    <div style={{ position: "relative", minWidth: 300 }}>
      <svg
        style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}
        width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={T.muted} strokeWidth="2.2" strokeLinecap="round"
      >
        <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <input
        type="search"
        value={value}
        onChange={onChange}
        placeholder="Pesquisar (separe os termos por vírgula)"
        style={{
          width: "100%", paddingLeft: 32, paddingRight: 12, paddingTop: 7, paddingBottom: 7,
          border: `1.5px solid ${T.border}`, borderRadius: 8, fontSize: 13,
          fontFamily: FONT, color: T.text, background: T.surface,
          outline: "none", transition: "border-color .15s, box-shadow .15s",
        }}
        onFocus={e => { e.target.style.borderColor = T.primary; e.target.style.boxShadow = `0 0 0 3px ${T.primary}18`; }}
        onBlur={e => { e.target.style.borderColor = T.border; e.target.style.boxShadow = "none"; }}
      />

    </div>
    <select
      value={ano}
      onChange={e => setAno(Number(e.target.value))}
      style={{
        padding: "7px 10px",
        border: `1.5px solid ${T.border}`,
        borderRadius: 8,
        fontSize: 13,
        fontFamily: FONT,
        color: T.text,
        background: T.surface,
        outline: "none",
        cursor: "pointer",
        transition: "border-color .15s, box-shadow .15s",
      }}
      onFocus={e => {
        e.target.style.borderColor = T.primary;
        e.target.style.boxShadow = `0 0 0 3px ${T.primary}18`;
      }}
      onBlur={e => {
        e.target.style.borderColor = T.border;
        e.target.style.boxShadow = "none";
      }}
    >
      <option value={2025}>2025</option>
      <option value={2026}>2026</option>
    </select>
  </div>
);

const Pill = ({ children, active, color, onClick }) => (
  <button
    onClick={onClick}
    style={{
      display: "inline-flex", alignItems: "center", gap: 5, padding: "5px 12px",
      borderRadius: 20, border: `1.5px solid ${active ? color : T.border}`,
      background: active ? `${color}12` : T.surface,
      color: active ? color : T.muted, fontSize: 12, fontWeight: 600,
      fontFamily: FONT, cursor: "pointer", transition: "all .15s",
      whiteSpace: "nowrap",
    }}
  >
    <span style={{ width: 7, height: 7, borderRadius: "50%", background: active ? color : T.muted, flexShrink: 0 }} />
    {children}
  </button>
);

const Th = ({ children, sticky = false, left = 0, style = {} }) => (
  <th style={{
    padding: "10px 14px", fontSize: 11, fontWeight: 700, color: T.textMid,
    textTransform: "uppercase", letterSpacing: ".6px", whiteSpace: "nowrap",
    background: T.surfaceAlt, borderBottom: `1.5px solid ${T.border}`,
    textAlign: "center", position: "sticky", top: 0,
    ...(sticky ? { left, zIndex: 30, boxShadow: "2px 0 4px rgba(0,0,0,.04)" } : { zIndex: 10 }),
    ...style,
  }}>{children}</th>
);

const ValorCell = ({
  mes,
  mostrarOrcado,
  mostrarRealizado,
  mostrarVariacao,
  onAbrirModal,
  selecionarValor,
  bp
}) => (

  <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: 1,
      alignItems: "center"
    }}
  >

    {mostrarOrcado && (
      <div
        title={"Orçado: " + mes.mes}
        onClick={(e) => {
          selecionarValor(
            e,
            mes.valorOrcado,
            `${bp.contaContabilDescricao} - ${mes.mes} - Orçado`
          );
        }}
        style={{
          fontSize: 12,
          color: T.primary,
          fontWeight: 600,
          cursor: "pointer",
          padding: "1px 4px",
          borderRadius: 4
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#e9effd";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "transparent";
        }}
      >
        {moeda(mes.valorOrcado)}
      </div>
    )}

    {mostrarRealizado && (
      <div
        title={"Realizado: " + mes.mes}
        onClick={(e) => {

          selecionarValor(
            e,
            mes.valorRealizado,
            `${bp.contaContabilDescricao} - ${mes.mes} - Realizado`
          );

        }}
        style={{
          fontSize: 12,
          color: T.secondary,
          fontWeight: 500,
          cursor: "pointer",
          padding: "1px 4px",
          borderRadius: 4
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#f0f2f5";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "transparent";
        }}
      >
        {moeda(mes.valorRealizado)}
      </div>
    )}

    {mostrarVariacao && (
      <div
        title={"Variação: " + mes.mes}
        onClick={(e) => {

          selecionarValor(
            e,
            mes.variacao,
            `${bp.contaContabilDescricao} - ${mes.mes} - Variação`
          );


        }}
        style={{
          fontSize: 11,
          fontWeight: 700,
          color: mes.variacao < 0 ? T.red : T.green,
          cursor: "pointer",
          padding: "1px 4px",
          borderRadius: 4
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background =
            mes.variacao < 0
              ? T.redLight
              : T.greenLight;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "transparent";
        }}
      >
        {moeda(mes.variacao)}
      </div>
    )}

  </div>
);

const Badge = ({ label, value, color }) => (
  <div style={{
    display: "flex", flexDirection: "column", alignItems: "center",
    background: `${color}10`, border: `1px solid ${color}30`,
    borderRadius: 8, padding: "4px 10px", minWidth: 90,
  }}>
    <span style={{ fontSize: 10, color, fontWeight: 700, textTransform: "uppercase", letterSpacing: .5 }}>{label}</span>
    <span style={{ fontSize: 12, color: T.text, fontWeight: 600 }}>{value}</span>
  </div>
);

// ─── Modal header tag ─────────────────────────────────────────────────────────
const Tag = ({ children, color }) => (
  <span style={{
    display: "inline-flex", alignItems: "center", padding: "2px 8px",
    borderRadius: 6, background: `${color}15`, color, fontSize: 11, fontWeight: 600,
  }}>{children}</span>
);

// ─── Main component ───────────────────────────────────────────────────────────
function TabelaPrevistoRealizado({ selectedFilters, atualizar }) {
  const service = new BPService();
  const despesaService = new DespesaService();

  const [ano, setAno] = useState(2026);
  const [data, setData] = useState(initialLista);
  const [listaDespesa, setListaDespesa] = useState([]);
  const [filtro, setFiltro] = useState("");
  const [filtroDebounced, setFiltroDebounced] = useState("");
  const [loading, setLoading] = useState(true);
  const [modo, setModo] = useState("BP");
  const [mostrarOrcado, setMostrarOrcado] = useState(true);
  const [mostrarRealizado, setMostrarRealizado] = useState(true);
  const [mostrarVariacao, setMostrarVariacao] = useState(true);
  const [mostrarComOrcado, setMostrarComOrcado] = useState(false);
  const [mostrarComRealizado, setMostrarComRealizado] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [loadingDespesa, setLoadingDespesa] = useState(false);
  const [bpSelected, setBpSelected] = useState({});
  const [nota, setNota] = useState([]);
  const [viewMode, setViewMode] = useState("lista");
  const [showLegend, setShowLegend] = useState(false);
  const [page, setPage] = useState({ page: 0, size: 20, sortKey: "id", sortDirection: "desc" });
  const [valoresSelecionados, setValoresSelecionados] = useState([]);
  const [exportando, setExportando] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {

      setFiltroDebounced(filtro);

      setPage(p => {
        if (p.page === 0) return p;

        return { ...p, page: 0 };
      });

    }, 300);

    return () => clearTimeout(t);

  }, [filtro]);

  useEffect(() => {
    fetchData();
  }, [page, filtroDebounced, ano, atualizar]);

  useEffect(() => {

    const handleKeyDown = (e) => {

      if (e.key === "Escape") {
        setValoresSelecionados([]);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };

  }, []);

  const fetchData = () => {
    setLoading(true);
    service.relatorioPaginado(selectedFilters, ano, page, filtro, mostrarComOrcado, mostrarComRealizado)
      .then(res => setData(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  const abrirNotaCompleta = (historico, data) => {
    setLoadingDespesa(true);
    despesaService.listaPorHistorico({ historico, data })
      .then(res => { setNota(res.data); setViewMode("nota"); })
      .finally(() => setLoadingDespesa(false));
  };

  const abrirModal = (bp, mes) => {
    setBpSelected(bp);
    setShowModal(true);
    setLoadingDespesa(true);
    const promise = mes !== undefined
      ? despesaService.listaDespesasPorData(ano, mes, bp.filial, bp.centroCustoCodigo, bp.contaContabilCodigo)
      : despesaService.listaDespesasPorData(ano, mes, bp.filial, bp.centroCustoCodigo, bp.contaContabilCodigo);
    promise.then(res => setListaDespesa(res.data)).finally(() => setTimeout(() => setLoadingDespesa(false), 300));
  };

  const fecharModal = () => { setShowModal(false); setListaDespesa([]); setBpSelected({}); setViewMode("lista"); };
  const voltarLista = () => { setViewMode("lista"); setNota([]); };

  const exportarExcel = () => {
    setExportando(true);
    service.relatorioLista(selectedFilters, ano, {}, filtroDebounced, mostrarComOrcado, mostrarComRealizado)
      .then(res => exportarPrevistoRealizadoExcel(res.data, selectedFilters?.mes || [], ano))
      .catch(console.error)
      .finally(() => setExportando(false));
  };

  const valorTotalDespesa = listaDespesa.reduce((acc, o) => acc + o.valor, 0);

  if (modo === "DESP") {
    return <TabelaDespesas filtros={selectedFilters} filtro={filtro} service={despesaService} setModo={setModo} />;
  }

  const mesesSelecionados = selectedFilters?.mes || [];

  const mesesFiltrados = (data.content[0]?.meses || [])
    .map((m, idx) => ({ ...m, idx }))
    .filter(m => mesesSelecionados.length === 0 || mesesSelecionados.includes(m.idx + 1));

  const meses = mesesFiltrados.map(m => m.mes);

  const totais = (() => {

    const total = {
      acumuladoOrcado: 0,
      acumuladoRealizado: 0,
      acumuladoSaldo: 0,

      totalOrcado: 0,
      totalRealizado: 0,
      totalSaldo: 0,

      meses: {}
    };

    meses.forEach((mes) => {
      total.meses[mes] = {
        valorOrcado: 0,
        valorRealizado: 0,
        variacao: 0
      };
    });

    data.content.forEach((bp) => {

      total.acumuladoOrcado += bp.acumuladoOrcado || 0;
      total.acumuladoRealizado += bp.acumuladoRealizado || 0;
      total.acumuladoSaldo += bp.acumuladoSaldo || 0;

      total.totalOrcado += bp.totalOrcado || 0;
      total.totalRealizado += bp.totalRealizado || 0;
      total.totalSaldo += bp.totalSaldo || 0;

      bp.meses
        .map((mes, idx) => ({ mes, idx }))
        .filter(({ idx }) =>
          mesesSelecionados.length === 0 ||
          mesesSelecionados.includes(idx + 1)
        )
        .forEach(({ mes }) => {

          if (!total.meses[mes.mes]) {
            total.meses[mes.mes] = {
              valorOrcado: 0,
              valorRealizado: 0,
              variacao: 0
            };
          }

          total.meses[mes.mes].valorOrcado += mes.valorOrcado || 0;
          total.meses[mes.mes].valorRealizado += mes.valorRealizado || 0;
          total.meses[mes.mes].variacao += mes.variacao || 0;
        });
    });

    return total;
  })();

  const selecionarValor = (e, valor, label) => {

    if (!e.ctrlKey) {
      return false;
    }

    e.preventDefault();
    e.stopPropagation();

    setValoresSelecionados(prev => [
      ...prev,
      {
        valor: Number(valor || 0),
        label
      }
    ]);

    return true;
  };

  const somaSelecionados = valoresSelecionados.reduce(
    (acc, item) => acc + item.valor,
    0
  );

  const mediaSelecionados =
    valoresSelecionados.length > 0
      ? somaSelecionados / valoresSelecionados.length
      : 0;

  return (
    <>
      <style>{`.bp-row:hover td { background: #F1F5FB !important; }
        .bp-row td { transition: background .12s; }
        .mes-cell:hover { background: #EFF6FF !important; cursor: pointer; }
        .fade-in { animation: bpFade .25s ease; }
        @keyframes bpFade { from{opacity:0;transform:translateY(4px)} to{opacity:1;transform:none} }
      `}</style>

      <div className="mt-3" style={{
        background: T.surface, borderRadius: 16, border: `1px solid ${T.border}`,
        boxShadow: "0 2px 12px rgba(15,23,42,.07)", display: "flex", flexDirection: "column",
        maxHeight: "100vh", fontFamily: FONT, overflow: "hidden",
      }}>

        {/* ── Header ── */}
        <div style={{
          padding: "16px 20px 12px", borderBottom: `1px solid ${T.border}`,
          background: T.surfaceAlt, borderRadius: "16px 16px 0 0",
          display: "flex", flexDirection: "column", gap: 12,
        }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{
                width: 32, height: 32, background: T.primary, borderRadius: 8,
                display: "flex", alignItems: "center", justifyContent: "center",
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" /><line x1="3" y1="9" x2="21" y2="9" />
                  <line x1="9" y1="21" x2="9" y2="9" />
                </svg>
              </div>
              <div>
                <div style={{ fontSize: 15, fontWeight: 700, color: T.text }}>Detalhamento BP</div>
                <div style={{ fontSize: 11, color: T.muted }}>Previsto × Realizado por conta e centro de custo</div>
              </div>
            </div>

            <div style={{ display: "flex", gap: 8 }}>
              <button onClick={exportarExcel} disabled={exportando} style={{
                display: "inline-flex", alignItems: "center", gap: 6,
                padding: "7px 14px", borderRadius: 8, border: `1.5px solid ${T.border}`,
                background: T.surface, color: T.textMid, fontSize: 12, fontWeight: 600,
                fontFamily: FONT, cursor: exportando ? "wait" : "pointer", transition: "all .15s",
                opacity: exportando ? .6 : 1,
              }}
                onMouseEnter={e => !exportando && (e.currentTarget.style.borderColor = T.green)}
                onMouseLeave={e => e.currentTarget.style.borderColor = T.border}
              >
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                {exportando ? "Exportando..." : "Exportar Excel"}
              </button>

              <button onClick={() => setModo("DESP")} style={{
                display: "inline-flex", alignItems: "center", gap: 6,
                padding: "7px 14px", borderRadius: 8, border: `1.5px solid ${T.border}`,
                background: T.surface, color: T.textMid, fontSize: 12, fontWeight: 600,
                fontFamily: FONT, cursor: "pointer", transition: "all .15s",
              }}
                onMouseEnter={e => e.currentTarget.style.borderColor = T.primary}
                onMouseLeave={e => e.currentTarget.style.borderColor = T.border}
              >
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                  <path d="M9 17H5a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v0a2 2 0 0 0-2-2h-4" />
                  <polyline points="12 3 12 15" /><polyline points="8 11 12 15 16 11" />
                </svg>
                Ver Lançamentos
              </button>
            </div>
          </div>

          {/* Controls row */}
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center" }}>
            <InputSearch value={filtro} onChange={e => setFiltro(e.target.value)} ano={ano} setAno={setAno} />

            {/* Visibility pills */}
            <Pill active={mostrarOrcado} color={T.primary} onClick={() => setMostrarOrcado(o => !o)}>Orçado</Pill>
            <Pill active={mostrarRealizado} color={T.secondary} onClick={() => setMostrarRealizado(o => !o)}>Realizado</Pill>
            <Pill active={mostrarVariacao} color={T.green} onClick={() => setMostrarVariacao(o => !o)}>Variação</Pill>

            {/* Legend toggle */}
            <div style={{ position: "relative" }}>
              <button
                onClick={() => setShowLegend(l => !l)}
                style={{
                  display: "inline-flex", alignItems: "center", gap: 5,
                  padding: "5px 12px", borderRadius: 8, border: `1.5px solid ${T.border}`,
                  background: showLegend ? T.primaryLight : T.surface,
                  color: showLegend ? T.primary : T.muted, fontSize: 12, fontWeight: 600,
                  fontFamily: FONT, cursor: "pointer",
                }}
              >
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                  <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                Legenda
              </button>

              {showLegend && (
                <div style={{
                  position: "absolute", top: "calc(100% + 6px)", left: 0, zIndex: 50,
                  background: T.surface, border: `1.5px solid ${T.border}`, borderRadius: 10,
                  boxShadow: "0 8px 24px rgba(15,23,42,.12)", padding: "12px 16px",
                  minWidth: 260, display: "flex", flexDirection: "column", gap: 10,
                }}>
                  {[
                    { color: T.primary, label: "Valores Orçados" },
                    { color: T.secondary, label: "Valores Realizados" },
                    { color: T.green, label: "Variação Positiva (Orçado − Realizado)" },
                    { color: T.red, label: "Variação Negativa (Orçado − Realizado)" },
                  ].map(({ color, label }) => (
                    <div key={label} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <span style={{ width: 12, height: 12, borderRadius: 3, background: color, flexShrink: 0 }} />
                      <span style={{ fontSize: 13, color: T.textMid }}>{label}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                cursor: "default",
                gap: 6,
                padding: "5px 10px",
                borderRadius: 8,
                background: T.primaryLight,
                border: `1px solid ${T.primary}25`,
                color: T.primary,
                fontSize: 11,
                fontWeight: 600,
                fontFamily: FONT,
                whiteSpace: "nowrap"
              }}
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
              >
                <path d="M12 20V10" />
                <path d="M18 20V4" />
                <path d="M6 20v-4" />
              </svg>

              CTRL + Clique nos números para somar valores
            </div>
          </div>
        </div>

        {/* ── Table ── */}
        <div style={{ overflow: "auto", flex: 1 }}>
          <table style={{ minWidth: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr>
                <Th sticky left={0} style={{ textAlign: "left", minWidth: 220 }}>Conta / C.Custo</Th>
                <Th style={{ minWidth: 130, textAlign: "left" }}>Grupo / Tipo</Th>
                <Th style={{ minWidth: 100 }}>Unidade</Th>
                <Th style={{ minWidth: 110 }}>Responsável</Th>
                {meses.map((m, i) => (
                  <Th key={i} style={{ minWidth: 130 }}>{m}</Th>
                ))}
                <Th style={{ minWidth: 140, background: T.acum, color: T.acumText }}>Acumulado</Th>
                <Th style={{ minWidth: 140, background: T.surfaceAlt }}>Total</Th>
              </tr>
            </thead>

            <tbody style={{ opacity: loading ? .45 : 1, pointerEvents: loading ? "none" : "auto", transition: "opacity .2s" }}>
              {data.content.length === 0 && !loading && (
                <tr>
                  <td colSpan={4 + meses.length + 2} style={{ padding: "40px 0", textAlign: "center", color: T.muted, fontSize: 14 }}>
                    Nenhum resultado encontrado.
                  </td>
                </tr>
              )}

              {data.content.map((bp, i) => (
                <tr key={i} className="bp-row fade-in">
                  {/* Conta / CC */}
                  <td
                    onClick={() => abrirModal(bp)}
                    style={{
                      padding: "10px 14px", background: T.surface, position: "sticky", left: 0, zIndex: 20,
                      borderBottom: `1px solid ${T.border}`, cursor: "pointer",
                      boxShadow: "2px 0 4px rgba(0,0,0,.04)", minWidth: 220,
                    }}
                  >
                    <div style={{ fontWeight: 700, color: T.text, fontSize: 13 }}>
                      {reduzirNome(bp.contaContabilDescricao)}
                      <span style={{ marginLeft: 5, fontSize: 11, color: T.textMid, fontWeight: 500 }}>
                        ({bp.contaContabilReduzido})
                      </span>
                    </div>
                    <div style={{ fontSize: 12, color: T.textMid, marginTop: 2 }}>
                      {bp.centroCustoDescricao}
                      <span style={{ marginLeft: 4, opacity: .8 }}>({bp.centroCustoCodigo})</span>
                    </div>
                  </td>

                  {/* Grupo / Tipo */}
                  <td onClick={() => abrirModal(bp)} style={{ padding: "10px 14px", background: T.surface, borderBottom: `1px solid ${T.border}`, cursor: "pointer", verticalAlign: "top" }}>
                    <div style={{ fontWeight: 600, color: T.textMid, fontSize: 12 }}>{bp.grupoDescricao}</div>
                    <div style={{ fontSize: 11, color: T.textMid, marginTop: 2 }}>{bp.contaContabilTipo}</div>
                  </td>

                  {/* Filial */}
                  <td onClick={() => abrirModal(bp)} style={{ padding: "10px 14px", textAlign: "center", background: T.surface, borderBottom: `1px solid ${T.border}`, cursor: "pointer" }}>
                    <span style={{
                      display: "inline-block", padding: "2px 8px", borderRadius: 6,
                      background: T.primaryLight, color: T.primary, fontSize: 11, fontWeight: 600,
                    }}>{bp.filial}</span>
                  </td>

                  {/* Responsável */}
                  <td onClick={() => abrirModal(bp)} style={{ padding: "10px 14px", textAlign: "center", background: T.surface, borderBottom: `1px solid ${T.border}`, cursor: "pointer" }}>
                    <span style={{ fontSize: 12, color: T.textMid, fontWeight: 500 }}>{bp.responsavel}</span>
                  </td>

                  {/* Meses */}
                  {bp.meses
                    .map((mes, idx) => ({ mes, idx }))
                    .filter(({ idx }) =>
                      mesesSelecionados.length === 0 ||
                      mesesSelecionados.includes(idx + 1)
                    )
                    .map(({ mes, idx }) => (
                      <td
                        key={idx}
                        onClick={(e) => {
                          if (!e.ctrlKey) {
                            abrirModal(bp, idx + 1)
                          }
                        }}
                        className="mes-cell"
                        style={{
                          padding: "8px 10px", textAlign: "center",
                          background: mes.variacao < 0 ? T.redLight : T.greenLight,
                          borderBottom: `1px solid ${T.border}`,
                          borderLeft: `1px solid ${T.border}`,
                          cursor: "pointer",
                        }}                      >

                        <ValorCell
                          mes={mes}
                          mostrarOrcado={mostrarOrcado}
                          mostrarRealizado={mostrarRealizado}
                          mostrarVariacao={mostrarVariacao}
                          selecionarValor={selecionarValor}
                          bp={bp}
                          onAbrirModal={() => abrirModal(bp, idx + 1)} />
                      </td>
                    ))}

                  {/* Acumulado */}
                  <td
                    style={{
                      padding: "8px 12px",
                      textAlign: "center",
                      background: T.acum,
                      borderBottom: `1px solid ${T.border}`,
                      borderLeft: `1.5px solid #C7D2FE`
                    }}
                  >

                    {mostrarOrcado && (
                      <div
                        onClick={(e) => {

                          const selecionou = selecionarValor(
                            e,
                            bp.acumuladoOrcado,
                            `${bp.contaContabilDescricao} - Acumulado - Orçado`
                          );

                          if (!selecionou) {
                            abrirModal(bp);
                          }
                        }}
                        style={{
                          fontSize: 12,
                          color: T.primary,
                          fontWeight: 600,
                          cursor: "pointer",
                          padding: "1px 4px",
                          borderRadius: 4
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = T.primaryLight;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "transparent";
                        }}
                      >
                        {moeda(bp.acumuladoOrcado)}
                      </div>
                    )}

                    {mostrarRealizado && (
                      <div
                        onClick={(e) => {

                          const selecionou = selecionarValor(
                            e,
                            bp.acumuladoRealizado,
                            `${bp.contaContabilDescricao} - Acumulado - Realizado`
                          );

                          if (!selecionou) {
                            abrirModal(bp);
                          }
                        }}
                        style={{
                          fontSize: 12,
                          color: T.secondary,
                          fontWeight: 500,
                          cursor: "pointer",
                          padding: "1px 4px",
                          borderRadius: 4
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "#E2E8F0";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "transparent";
                        }}
                      >
                        {moeda(bp.acumuladoRealizado)}
                      </div>
                    )}

                    {mostrarVariacao && (
                      <div
                        onClick={(e) => {

                          const selecionou = selecionarValor(
                            e,
                            bp.acumuladoSaldo,
                            `${bp.contaContabilDescricao} - Acumulado - Variação`
                          );

                          if (!selecionou) {
                            abrirModal(bp);
                          }
                        }}
                        style={{
                          fontSize: 11,
                          fontWeight: 700,
                          color: bp.acumuladoSaldo < 0 ? T.red : T.green,
                          cursor: "pointer",
                          padding: "1px 4px",
                          borderRadius: 4
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background =
                            bp.acumuladoSaldo < 0
                              ? T.redLight
                              : T.greenLight;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "transparent";
                        }}
                      >
                        {moeda(bp.acumuladoSaldo)}
                      </div>
                    )}

                  </td>

                  {/* Total */}
                  <td
                    style={{
                      padding: "8px 12px",
                      textAlign: "center",
                      background: T.surfaceAlt,
                      borderBottom: `1px solid ${T.border}`,
                      borderLeft: `1.5px solid ${T.borderStrong}`
                    }}
                  >

                    {mostrarOrcado && (
                      <div
                        onClick={(e) => {

                          const selecionou = selecionarValor(
                            e,
                            bp.totalOrcado,
                            `${bp.contaContabilDescricao} - Total - Orçado`
                          );

                          if (!selecionou) {
                            abrirModal(bp);
                          }
                        }}
                        style={{
                          fontSize: 12,
                          color: T.primary,
                          fontWeight: 600,
                          cursor: "pointer",
                          padding: "1px 4px",
                          borderRadius: 4
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = T.primaryLight;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "transparent";
                        }}
                      >
                        {moeda(bp.totalOrcado)}
                      </div>
                    )}

                    {mostrarRealizado && (
                      <div
                        onClick={(e) => {

                          const selecionou = selecionarValor(
                            e,
                            bp.totalRealizado,
                            `${bp.contaContabilDescricao} - Total - Realizado`
                          );

                          if (!selecionou) {
                            abrirModal(bp);
                          }
                        }}
                        style={{
                          fontSize: 12,
                          color: T.secondary,
                          fontWeight: 500,
                          cursor: "pointer",
                          padding: "1px 4px",
                          borderRadius: 4
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "#E2E8F0";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "transparent";
                        }}
                      >
                        {moeda(bp.totalRealizado)}
                      </div>
                    )}

                    {mostrarVariacao && (
                      <div
                        onClick={(e) => {

                          const selecionou = selecionarValor(
                            e,
                            bp.totalSaldo,
                            `${bp.contaContabilDescricao} - Total - Variação`
                          );

                          if (!selecionou) {
                            abrirModal(bp);
                          }
                        }}
                        style={{
                          fontSize: 11,
                          fontWeight: 700,
                          color: bp.totalSaldo < 0 ? T.red : T.green,
                          cursor: "pointer",
                          padding: "1px 4px",
                          borderRadius: 4
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background =
                            bp.totalSaldo < 0
                              ? T.redLight
                              : T.greenLight;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "transparent";
                        }}
                      >
                        {moeda(bp.totalSaldo)}
                      </div>
                    )}

                  </td>
                </tr>
              ))}

              <tr
                style={{
                  bottom: 0,
                  zIndex: 15
                }}
              >
                {/* Conta */}
                <td
                  style={{
                    padding: "12px 14px",
                    background: T.surfaceAlt,
                    fontWeight: 700,
                    color: T.text,
                    position: "sticky",
                    left: 0,
                    zIndex: 25
                  }}
                >
                  Total da Página
                  <div
                    style={{
                      fontSize: 10,
                      fontWeight: 500,
                      color: T.textMid,
                      marginTop: 2
                    }}
                  >
                    Soma dos registros exibidos nesta página
                  </div>
                </td>

                {/* Grupo */}
                <td
                  style={{
                    padding: "12px",
                    background: T.surfaceAlt,
                    fontSize: 11,
                    color: T.textMid
                  }}
                >
                </td>

                {/* Unidade */}
                <td
                  style={{
                    padding: "12px",
                    background: T.surfaceAlt,
                    fontSize: 11,
                    color: T.textMid,
                    textAlign: "center"
                  }}
                >
                </td>

                {/* Responsável */}
                <td
                  style={{
                    padding: "12px",
                    background: T.surfaceAlt,
                    fontSize: 11,
                    color: T.textMid,
                    textAlign: "center"
                  }}
                >
                </td>

                {/* Meses */}
                {meses.map((mes, idx) => {

                  const totalMes = totais.meses[mes];

                  return (
                    <td
                      key={idx}
                      style={{
                        padding: "10px",
                        textAlign: "center",
                        background: T.surfaceAlt,
                        borderLeft: `1px solid ${T.border}`
                      }}
                    >
                      {mostrarOrcado && (
                        <div
                          style={{
                            fontSize: 12,
                            color: T.primary,
                            fontWeight: 700
                          }}
                        >
                          {moeda(totalMes.valorOrcado)}
                        </div>
                      )}

                      {mostrarRealizado && (
                        <div
                          style={{
                            fontSize: 12,
                            color: T.secondary,
                            fontWeight: 600
                          }}
                        >
                          {moeda(totalMes.valorRealizado)}
                        </div>
                      )}

                      {mostrarVariacao && (
                        <div
                          style={{
                            fontSize: 11,
                            fontWeight: 700,
                            color:
                              totalMes.variacao < 0
                                ? T.red
                                : T.green
                          }}
                        >
                          {moeda(totalMes.variacao)}
                        </div>
                      )}
                    </td>
                  );
                })}

                {/* Acumulado */}
                <td
                  style={{
                    padding: "10px",
                    textAlign: "center",
                    background: T.surfaceAlt,
                    borderLeft: `1px solid ${T.border}`
                  }}
                >
                  {mostrarOrcado && (
                    <div style={{ fontSize: 12, color: T.primary, fontWeight: 700 }}>
                      {moeda(totais.acumuladoOrcado)}
                    </div>
                  )}

                  {mostrarRealizado && (
                    <div style={{ fontSize: 12, color: T.secondary, fontWeight: 600 }}>
                      {moeda(totais.acumuladoRealizado)}
                    </div>
                  )}

                  {mostrarVariacao && (
                    <div
                      style={{
                        fontSize: 11,
                        fontWeight: 700,
                        color:
                          totais.acumuladoSaldo < 0
                            ? T.red
                            : T.green
                      }}
                    >
                      {moeda(totais.acumuladoSaldo)}
                    </div>
                  )}
                </td>

                {/* Total */}
                <td
                  style={{
                    padding: "10px",
                    textAlign: "center",
                    background: T.surfaceAlt,
                    borderLeft: `1px solid ${T.border}`
                  }}
                >
                  {mostrarOrcado && (
                    <div style={{ fontSize: 12, color: T.primary, fontWeight: 700 }}>
                      {moeda(totais.totalOrcado)}
                    </div>
                  )}

                  {mostrarRealizado && (
                    <div style={{ fontSize: 12, color: T.secondary, fontWeight: 600 }}>
                      {moeda(totais.totalRealizado)}
                    </div>
                  )}

                  {mostrarVariacao && (
                    <div
                      style={{
                        fontSize: 11,
                        fontWeight: 700,
                        color:
                          totais.totalSaldo < 0
                            ? T.red
                            : T.green
                      }}
                    >
                      {moeda(totais.totalSaldo)}
                    </div>
                  )}
                </td>
              </tr>

            </tbody>
          </table>

          {loading && (
            <div style={{ display: "flex", justifyContent: "center", padding: 32 }}>
              <Loading />
            </div>
          )}
        </div>

        {/* ── Pagination ── */}
        <div className="pb-3" style={{ borderTop: `1px solid ${T.border}`, background: T.surfaceAlt, borderRadius: "0 0 16px 16px" }}>
          <PageAPI
            page={data.page.number}
            size={data.page.size}
            totalElements={data.page.totalElements}
            totalPages={data.page.totalPages}
            loading={loading}
            onPageChange={newPage => setPage(p => ({ ...p, page: newPage }))}
            onPageSizeChange={newSize => setPage(p => ({ ...p, size: newSize }))}
          />
        </div>
      </div>

      {/* ── Modal ── */}
      <Dialog
        visible={showModal}
        header={
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Tag color={T.secondary}>{bpSelected.filial}</Tag>
              {viewMode === "lista" ? (
                <Tag color={T.primary}>Despesas</Tag>
              ) : (
                <Tag color={T.primary}>Lançamento</Tag>
              )}
              <span style={{ fontSize: 15, fontWeight: 700, color: T.text }}>
                {viewMode === "lista"
                  ? bpSelected.centroCustoDescricao
                  : "Lançamento Detalhado"}
              </span>
            </div>
            {viewMode === "lista" ? (
              <div style={{ fontSize: 12, color: T.muted, display: "flex", gap: 8, flexWrap: "wrap" }}>
                <span>C.Custo: <strong>{bpSelected.centroCustoCodigo}</strong></span>
                <span>·</span>
                <span>Conta: <strong>{bpSelected.contaContabilReduzido}</strong></span>
              </div>
            ) : (
              <div style={{ fontSize: 12, color: T.muted }}>{nota[0]?.historico}</div>
            )}
          </div>
        }
        onHide={fecharModal}
        blockScroll
        className="min-w-[80%]"
        contentClassName="p-0"
        footer={
          <div className="pt-4" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
            <div style={{ display: "flex", gap: 9 }}>
              {viewMode === "lista" && mostrarOrcado && (
                <Badge label="Total" value={`R$ ${formatarMoedaBrasileira(valorTotalDespesa)}`} color={T.primary} />
              )}
              {viewMode === "nota" && (
                <Badge
                  label="Total da nota"
                  value={`R$ ${formatarMoedaBrasileira(nota.reduce((acc, i) => acc + (i.valor || 0), 0))}`}
                  color={T.secondary}
                />
              )}
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              {viewMode === "nota" && (
                <button onClick={voltarLista} style={{
                  padding: "7px 16px", borderRadius: 8, border: `1.5px solid ${T.border}`,
                  background: T.surface, color: T.textMid, fontSize: 13, fontWeight: 600,
                  fontFamily: FONT, cursor: "pointer",
                }}>← Voltar</button>
              )}
              <button onClick={fecharModal} style={{
                padding: "7px 18px", borderRadius: 8, border: "none",
                background: T.primary, color: "#fff", fontSize: 13, fontWeight: 700,
                fontFamily: FONT, cursor: "pointer",
              }}>Fechar</button>
            </div>
          </div>
        }
      >
        <div style={{ overflowX: "auto" }}>
          {viewMode === "lista" ? (
            /* ── Tabela de despesas ── */
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13, fontFamily: FONT }}>
              <thead>
                <tr style={{ background: T.surfaceAlt }}>
                  {["Data", "Histórico", "C.Custo", "Conta", "Valor", "Lançamento"].map((h, i) => (
                    <th key={h} style={{
                      padding: "9px 12px", fontSize: 11, fontWeight: 700, color: T.muted,
                      textTransform: "uppercase", letterSpacing: .5,
                      textAlign: i >= 4 ? "right" : "left",
                      borderBottom: `1.5px solid ${T.border}`,
                    }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loadingDespesa ? (
                  <tr><td colSpan={6} style={{ padding: 32, textAlign: "center" }}><Loading /></td></tr>
                ) : listaDespesa.length > 0 ? (() => {
                  const grouped = {};

                  listaDespesa.forEach(item => {
                    const [datePart] = item.data.split("T");
                    const [ano, mes] = datePart.split("-").map(Number);

                    const key = new Date(ano, mes - 1, 1).toLocaleString("pt-BR", {
                      month: "long",
                      year: "numeric"
                    });

                    if (!grouped[key]) {
                      grouped[key] = [];
                    }

                    grouped[key].push(item);
                  });

                  return Object.entries(grouped).map(([mes, despesas], gi) => (
                    <React.Fragment key={gi}>
                      <tr>
                        <td colSpan={6} style={{
                          padding: "6px 12px", background: T.primaryLight, borderBottom: `1px solid ${T.border}`,
                          fontSize: 12, fontWeight: 700, color: T.primary, letterSpacing: .3,
                        }}>
                          {mes.charAt(0).toUpperCase() + mes.slice(1)}
                        </td>
                      </tr>
                      {despesas.map((d, j) => (
                        <tr key={j} className="fade-in" style={{

                          transition: "background .1s",
                        }}>
                          <td style={{ padding: "8px 12px", color: T.muted, whiteSpace: "nowrap", borderBottom: `1px solid ${T.border}` }}>{returnDate(d.data)}</td>
                          <td style={{ padding: "8px 12px", color: T.text, borderBottom: `1px solid ${T.border}`, maxWidth: 280, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{d.historico}</td>
                          <td style={{ padding: "8px 12px", color: T.muted, textAlign: "center", borderBottom: `1px solid ${T.border}` }}>{d.centroCustoCodigo}</td>
                          <td style={{ padding: "8px 12px", color: T.muted, textAlign: "center", borderBottom: `1px solid ${T.border}` }}>{d.contaContabilReduzido}</td>
                          <td style={{ padding: "8px 12px", color: T.text, fontWeight: 600, textAlign: "right", whiteSpace: "nowrap", borderBottom: `1px solid ${T.border}` }}>
                            R$ {formatarMoedaBrasileira(d.valor)}
                          </td>
                          <td style={{ padding: "8px 12px", textAlign: "right", borderBottom: `1px solid ${T.border}` }}>
                            <button
                              onClick={() => abrirNotaCompleta(d.historico, d.data)}
                              style={{
                                background: "none", border: "none", color: T.primary, fontSize: 12,
                                fontWeight: 600, cursor: "pointer", textDecoration: "underline", fontFamily: FONT,
                              }}
                            >Ver nota</button>
                          </td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ));
                })() : (
                  <tr><td colSpan={6} style={{ padding: 32, textAlign: "center", color: T.muted }}>Nenhuma despesa encontrada.</td></tr>
                )}
              </tbody>
            </table>
          ) : (
            /* ── Tabela nota detalhada ── */
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13, fontFamily: FONT }}>
              <thead>
                <tr style={{ background: T.surfaceAlt }}>
                  {["Data", "Histórico", "C.Custo", "Conta", "Valor"].map((h, i) => (
                    <th key={h} style={{
                      padding: "9px 12px", fontSize: 11, fontWeight: 700, color: T.muted,
                      textTransform: "uppercase", letterSpacing: .5,
                      textAlign: i === 4 ? "right" : "left",
                      borderBottom: `1.5px solid ${T.border}`,
                    }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loadingDespesa ? (
                  <tr><td colSpan={5} style={{ padding: 32, textAlign: "center" }}><Loading /></td></tr>
                ) : nota.length > 0 ? nota.map((item, i) => (
                  <tr key={i} style={{ background: i % 2 === 1 ? T.surfaceAlt : T.surface }}>
                    <td style={{ padding: "8px 12px", color: T.muted, whiteSpace: "nowrap", borderBottom: `1px solid ${T.border}` }}>{returnDate(item.data)}</td>
                    <td style={{ padding: "8px 12px", color: T.text, borderBottom: `1px solid ${T.border}` }}>{item.historico}</td>
                    <td style={{ padding: "8px 12px", color: T.muted, textAlign: "center", borderBottom: `1px solid ${T.border}` }}>{item.centroCustoCodigo}</td>
                    <td style={{ padding: "8px 12px", color: T.muted, textAlign: "center", borderBottom: `1px solid ${T.border}` }}>{item.contaContabilReduzido}</td>
                    <td style={{ padding: "8px 12px", fontWeight: 600, color: T.text, textAlign: "right", borderBottom: `1px solid ${T.border}` }}>
                      R$ {formatarMoedaBrasileira(item.valor)}
                    </td>
                  </tr>
                )) : (
                  <tr><td colSpan={5} style={{ padding: 32, textAlign: "center", color: T.muted }}>Nenhum lançamento encontrado.</td></tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </Dialog>

      {valoresSelecionados.length > 0 && (
        <div
          style={{
            position: "fixed",
            bottom: 20,
            left: 20,
            zIndex: 9999,
            background: T.surface,
            border: `1px solid ${T.border}`,
            borderRadius: 12,
            boxShadow: "0 10px 30px rgba(0,0,0,.15)",
            padding: "14px 16px",
            minWidth: 240,
            fontFamily: FONT
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 10
            }}
          >
            <div
              style={{
                fontSize: 13,
                fontWeight: 700,
                color: T.text
              }}
            >
              Valores Selecionados
            </div>

            <button
              onClick={() => setValoresSelecionados([])}
              style={{
                border: "none",
                background: "none",
                cursor: "pointer",
                color: T.red,
                fontWeight: 700
              }}
            >
              ✕
            </button>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 6
            }}
          >
            <div style={{ fontSize: 12 }}>
              <strong>Itens:</strong> {valoresSelecionados.length}
            </div>

            <div style={{ fontSize: 12 }}>
              <strong>Soma:</strong> {moeda(somaSelecionados)}
            </div>

            <div style={{ fontSize: 12 }}>
              <strong>Média:</strong> {moeda(mediaSelecionados)}
            </div>
          </div>

          <div
            style={{
              marginTop: 10,
              maxHeight: 120,
              overflow: "auto",
              borderTop: `1px solid ${T.border}`,
              paddingTop: 8
            }}
          >
            {valoresSelecionados.map((item, idx) => (
              <div
                key={idx}
                style={{
                  fontSize: 11,
                  color: T.textMid,
                  marginBottom: 4
                }}
              >
                {item.label}: {moeda(item.valor)}
              </div>
            ))}
          </div>

          <div
            style={{
              marginTop: 10,
              fontSize: 10,
              color: T.muted
            }}
          >
            CTRL + clique para acumular • ESC limpa
          </div>
        </div>
      )}
    </>
  );
}

export default TabelaPrevistoRealizado;
